import PropTypes from "prop-types";
import content from "app-content";
import classnames from "classnames";
import styles from "./index.css";

const Button = ({ action, contentKey, className }) => (
  <button className={classnames(styles.button, className)} onClick={action}>
    {content[contentKey]}
  </button>
);

Button.propTypes = {
  action: PropTypes.func.isRequired,
  contentKey: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default Button;
